import { Button } from '@/components/ui/button';
import { ImageUploader } from '@/components/ui/image-uploader';
import { useIsMobile } from '@/lib/utils';
import { XCircleIcon } from 'lucide-react';
import { useCallback, useState } from 'react';

export const ImagesInput = ({
  maxFileCount,
  onFileUuidsChange,
}: {
  maxFileCount?: number;
  onFileUuidsChange?: (files: string[]) => void;
}) => {
  const [fileUuids, setFileUuids] = useState<(string | null)[]>([null]);
  const isMobile = useIsMobile();

  const updateFileUuids = useCallback(
    (newFiles: (string | null)[]) => {
      setFileUuids(newFiles);
      onFileUuidsChange?.(newFiles.filter(Boolean) as string[]);
    },
    [onFileUuidsChange],
  );

  return (
    <div className="flex flex-row flex-nowrap gap-3 overflow-x-auto overflow-y-hidden pt-3">
      {fileUuids.map((fileUuid, index) => (
        <div key={index} className="relative">
          <ImageUploader
            className={isMobile ? 'size-[10rem]' : 'size-[13rem]'}
            fileUuid={fileUuid}
            onFileUuidChange={(file) => {
              const newFiles = fileUuids.with(index, file);
              if (
                index === fileUuids.length - 1 &&
                file &&
                (!maxFileCount || fileUuids.length < maxFileCount)
              ) {
                newFiles.push(null);
              }
              updateFileUuids(newFiles);
            }}
          />
          {fileUuid && (
            <Button
              size="icon"
              variant="ghost"
              className="absolute right-0 top-0 z-10 size-6 -translate-y-1/2 translate-x-1/2 rounded-full bg-background"
              onClick={() => {
                const newFiles = fileUuids.toSpliced(index, 1);
                if (newFiles.at(-1) !== null) {
                  newFiles.push(null);
                }
                updateFileUuids(newFiles);
              }}
              type="button"
            >
              <XCircleIcon className="text-muted-foreground" />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};
